<template>
    <div class="Field__Component">
        <div>
            <slot>{{ getExpoType(value) }}</slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FieldStandard',
    props: ['value'],
    methods: {
        getExpoType(type) {
            switch (type) {
                case 0:
                    return 'רגיל';
                case 1:
                    return 'חקיקה';
                case 2:
                    return 'מיקודית';
                case 3:
                    return 'חזרה';

                default:
                    return 'רגיל';
            }
        }
    }
};
</script>

<style scoped></style>
